/**
 * Representa uma resposta de uma chamada de Health Check.
 */
class HealthCheckResposta {
    static STATUS_OK = 'OK';
    static STATUS_ALERTA = 'ALERTA';
    static STATUS_ERRO = 'ERRO';
    static STATUS_FALHA = 'FALHA';

    constructor(nome, url, respostaJson) {
        this.url = url;
        this.status = respostaJson && respostaJson.status && respostaJson.status.tipo;
        this.nome = nome;
        this.versao = respostaJson && respostaJson.info && respostaJson.info.versaoApp;
        this.outrasInformacoes = respostaJson && this._buildOutrasInformacoes(respostaJson);
        this.filhos =
            respostaJson &&
            respostaJson.status &&
            respostaJson.status.detalhes &&
            respostaJson.status.detalhes.descricoes;
    }

    static sucesso(nome, url, respostaJson) {
        let instancia = new HealthCheckResposta(nome, url, respostaJson);
        instancia.status = HealthCheckResposta.STATUS_OK;
        return instancia;
    }

    static falha(nome, url) {
        let instancia = new HealthCheckResposta(nome, url, null);
        instancia.status = HealthCheckResposta.STATUS_FALHA;
        return instancia;
    }

    _buildOutrasInformacoes(respostaJson) {
        return respostaJson.info.numeroBuild
            ? `(Build ${respostaJson.info.numeroBuild} ${new Date(respostaJson.info.dataBuild).toLocaleDateString()})`
            : null;
    }
}

export default HealthCheckResposta;
